import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import { RxCross2 } from "react-icons/rx";
import React, { useEffect } from "react";
import styles from "./Dashboard.module.css";
import { CreditCard } from "@mui/icons-material";
import { FaRegAddressCard } from "react-icons/fa6";
import { Box, Grid, Typography, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  viewCredit,
  fetchMyCredit,
  fetchManagerConfigurations,
  creditTransfer,
} from "../../redux/credit/creditSlice"; // Import Redux actions
import { useState } from "react";
import { customTextColor, formatDate } from "../../utils/const";
import { getProfile } from "../../redux/profile/profileSlice";
import { useNavigate } from "react-router-dom";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "37px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "37px", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "10px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "37px", // Adjust label position when it shrinks
  },
};
function TransForCreditDrawer({ handleClose, show, handleShowAddCredit }) {
  const [credit, setCredit] = useState("");
  const [userError, setuserError] = useState("");
  const [creditError, setCreditError] = useState("");
  const [typeError, setTypeError] = useState("");
  const [userID, setUserID] = useState("");
  const dispatch = useDispatch();
  const myCredit = useSelector((state) => state.credit.creditDetails?.data);
  const creditStatus = useSelector((state) => state.credit?.status);

  useEffect(() => {
    dispatch(fetchMyCredit());
    dispatch(getProfile());
    dispatch(fetchManagerConfigurations());
    dispatch(viewCredit());
  }, [dispatch]);

  useEffect(() => {
    if (creditStatus === "credit_transfer_succeeded") {
      dispatch(fetchMyCredit());
      setCredit("");
      setUserID("")
    }
  }, [creditStatus]);

  const handleClickAddCredit = () => {
    handleClose();
    handleShowAddCredit();
  };

  useEffect(() => {
    if (!show) {
      setUserID("");
      setCredit("");
    }
  }, [show]);

  const handleCreditTransfer = () => {
    let valid = true;

    // Reset all errors
    setCreditError("");
    setTypeError("");
    setuserError("");

    // Credit validation
    if (!credit || parseFloat(credit) <= 0) {
      setCreditError("Please enter a valid credit amount");
      valid = false;
    }

    // Type selection validation
    if (!userID) {
      setuserError("Please select a user");
      valid = false;
    }

    if (!valid) return;

    const transferData = {
      transfer_to_user_id: [userID], // Update this appropriately
      amount: credit,
    };

    dispatch(creditTransfer(transferData));
  };
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="end"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        marginTop: "74px",
        width: "35%",
        // padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <button
          className={styles.pay_credit_btn}
          onClick={handleClickAddCredit}
          style={{ backgroundColor: "#4287f5", marginTop: "0" }}
        >
          Add Credit
        </button>
        <RxCross2
          style={{
            fontSize: "22px",
            cursor: "pointer",
            color: customTextColor,
          }}
          onClick={handleClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body style={{ padding: "0" }}>
        <Box>
          <Box className={styles.creditViewSection}>
            <Typography>
              Available Credit{" "}
              <a style={{ fontSize: "20px" }}>
                <b>{myCredit?.total_credits}</b>
              </a>
            </Typography>
            <Typography>
              Received {myCredit?.earned_credits} Bonus Credit
            </Typography>
            <Typography sx={{ marginBottom: "0 !important" }}>
              No transaction since{" "}
              {myCredit?.updated_at !== undefined &&
                formatDate(myCredit?.updated_at)}
            </Typography>
          </Box>

          <Box sx={{ backgroundColor: "#fff", margin: "20px" }}>
            <Typography>
              <b>Transfer Credits by User ID</b>
            </Typography>
            <Box sx={{ textAlign: "center" }}>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{
                    padding: "10px 20px 10px 0",
                    position: "relative",
                  }}
                >
                  <Box
                    className={styles.icon_style_credit}
                    sx={userError || typeError ? { top: "43%" } : {}}
                  >
                    <FaRegAddressCard style={{ fontSize: "27px" }} />
                  </Box>
                  <TextField
                    label="Enter UserName"
                    variant="standard"
                    sx={fieldStyle}
                    value={userID}
                    onChange={(e) => setUserID(e.target.value)}
                    error={!!userError}
                    helperText={userError}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  sx={{
                    padding: "10px 0 10px 0",
                    position: "relative",
                  }}
                >
                  <Box
                    className={styles.icon_style_credit}
                    sx={creditError || typeError ? { top: "43%" } : {}}
                  >
                    <CreditCard style={{ fontSize: "30px" }} />
                  </Box>
                  <TextField
                    label="Credit"
                    variant="standard"
                    sx={fieldStyle}
                    value={credit}
                    onChange={(e) => {
                      setCredit(e.target.value);
                      if (parseFloat(e.target.value) > 0) {
                        setCreditError("");
                      }
                    }}
                    error={!!creditError}
                    helperText={creditError}
                  />
                </Grid>
              </Grid>

              <button
                className={styles.pay_credit_btn}
                onClick={handleCreditTransfer}
              >
                {creditStatus === "loading" ? "Loading" : "Transfer"}
              </button>
            </Box>
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default TransForCreditDrawer;
